import dayjs from 'dayjs';
import { AuthData } from 'src/common/commonTypes';

const savePath = 'psp:user_info';

const saveData = (saveData: AuthData) => {
    localStorage.setItem(savePath, JSON.stringify(saveData));
};

const getData = (): AuthData | null => {
    const dataStr = localStorage.getItem(savePath);
    return dataStr ? JSON.parse(dataStr) : null;
};

const removeData = () => {
    localStorage.removeItem(savePath);
};

const getToken = () => {
    const data = getData();
    return data?.token;
};

const hasValidToken = (): boolean => {
    const saveData = getData();
    if (!saveData || !saveData.expiresIn) return false;
    return !isExpired(saveData.expiresIn);
};

const isExpired = (expiresIn: number): boolean => {
    const mExpiresAt = dayjs.unix(expiresIn);
    const res = mExpiresAt.isBefore(dayjs());
    return res;
};

const getAuthHeader = (token?: string) => {
    if (token) {
        return { Authorization: `Bearer ${token}` };
    }
    const savedToken = getToken();
    return savedToken ? { Authorization: `Bearer ${savedToken}` } : {};
};

const authService = {
    saveData,
    getData,
    removeData,
    hasValidToken,
    getAuthHeader
};

export default authService;
